module.exports = __webpack_public_path__ + "static/media/eua.36ab476e.svg";